export const filterCourierStatesByCompanyAndPool = (courierStateList = [], {companyId} = {}) => {
    let list = courierStateList || [];

    if (companyId === "pool") {
        list = list.filter(courierState => !courierState.dedicatedCompanyId);
    }

    return list;
};
